import { useCallback, useState } from "react"
import AssociadoInput from "../../models/AssociadoInput" 
import http from "../../../../http"

export const useCadastraAssociado = () => {
    const [resposta, setResposta] = useState({})

    const cadastrarAssociado = useCallback((inputsAssociado) => {
        const dadosUsusarioECadastro = AssociadoInput.create(inputsAssociado)
        http.post(`/cadastros`, dadosUsusarioECadastro)
            .then(res => {
                setResposta({ data: res.data, error: null })
            })
            .catch(error => {
                const { response } = error
                setResposta({ data: null, error: response })
            })
    }, [])
    return [resposta, cadastrarAssociado]
}